/** Plain words for a team's kind on the admin console (#2825). */
import { type TeamKind, resolveTeamHomeRoute } from "../../../lib/teamApps";

export function teamKindLabel(kind: string): string {
  if (kind === "scheduling") return "Roster";
  if (kind === "tasks") return "Map";
  return kind ? kind.charAt(0).toUpperCase() + kind.slice(1) : "";
}

/** The small word before a team name: "Demo", "Map", or nothing for a roster team. */
export function teamKicker(row: { is_demo: boolean; team_kind: string }): string | null {
  if (row.is_demo) return "Demo";
  if (row.team_kind === "scheduling") return null;
  return teamKindLabel(row.team_kind);
}

/** The team's own home: a Map team opens on its map. */
export function teamHomeFor(kind: string, teamId: string): string {
  const k: TeamKind = kind === "tasks" ? "tasks" : "scheduling";
  return resolveTeamHomeRoute(k, teamId);
}
